module.exports = new __parcel__URL__("dashboard.18e07180.svg").toString();